class SessionManager {
  static getErplySessionKey() {
    return sessionStorage.getItem('erplySessionKey');
  }

  static setErplySessionKey(erplySessionKey) {
    sessionStorage.setItem('erplySessionKey', erplySessionKey);
  }
}

class ApiService {
  static async fetchErplySessionKeyFromExternalAPI() {
    try {
      var requestOptions = {
        method: 'GET',
      };
      const response = await fetch('https://nptcrdlzp7mtbrfgu7dxy5e7fm0rhwud.lambda-url.ap-south-1.on.aws/',requestOptions);
      const data = await response.text();
      return data;
    } catch (error) {
      console.error('Error fetching session key:', error.message);
      throw error;
    }
  }

  static async fetchRewardPoints(erplySessionKey, customerEmail) {
    try {
      var requestOptions = {
        method: 'GET',
      };
      const response = await fetch(`https://rwxcvgwqucjiahg4rickic4s7a0eqzuj.lambda-url.ap-south-1.on.aws/?sessionKey=${erplySessionKey}&searchEmail=${customerEmail}`, requestOptions
      );

      const data = await response.text();
      return data;
    } catch (error) {
      console.error('Error fetching reward points:', error.message);
      throw error;
    }
  }

  static async verifySessionKey(erplySessionKey){
    try{
      var requestOptions = {
        method: 'GET',
      };
      const response = await fetch(`https://p2kkyx3vyhxuecgwbszjhu5ovq0lrkli.lambda-url.ap-south-1.on.aws/?sessionKey=${erplySessionKey}`, requestOptions
      );

      const data = await response.text();
      return data;
    } catch (error) {
      console.error('Erply Session Key expired:', error.message);
      throw error;
    }
  }
}

class CustomRewardPointsElement extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  async render() {
    let sessionKey = SessionManager.getErplySessionKey();
    if(sessionKey){
      const isValidSession = await ApiService.verifySessionKey(sessionKey);
      if (isValidSession == 0) {
        this.fetchAndRenderRewardPoints(sessionKey);
      } else {
        this.fetchErplySessionKeyAndRenderRewardPoints();
      }
    } else {
      this.fetchErplySessionKeyAndRenderRewardPoints();
    }
  }
  
  async fetchErplySessionKeyAndRenderRewardPoints() {
    try {
      const sessionKey = await ApiService.fetchErplySessionKeyFromExternalAPI();
      SessionManager.setErplySessionKey(sessionKey);

      const customerEmail = document.getElementById('customer-email').value;
      this.fetchAndRenderRewardPoints(sessionKey, customerEmail);
    } catch (error) {
      console.error('Error:', error.message);
    }
  }

  async fetchAndRenderRewardPoints(sessionKey, customerEmail) {
    try {
      const rewardPoints = await ApiService.fetchRewardPoints(sessionKey, customerEmail);

      this.innerHTML = `${rewardPoints}`;
    } catch (error) {
      console.error('Error fetching reward points:', error.message);
    }
  }
}

customElements.define('custom-reward-points', CustomRewardPointsElement);

